export const imageConstants = {
  logo: require('../assets/Images/logo-white.svg'),
  avatar: require('../assets/Images/placeholder-avatar.png'),
};
